document.addEventListener('DOMContentLoaded', function() {
    // Global variables to track state
    let bannerState = {
        interval: null,
        timeout: null,
        isInitialized: false
    };
    
    // Initialize banner functionality
    initializeBanner();
    
    // Handle window resize with debouncing
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            initializeBanner();
        }, 250);
    });
    
    // Function to clean up existing timers
    function cleanupBanner() {
        if (bannerState.interval) {
            clearInterval(bannerState.interval);
            bannerState.interval = null;
        }
        if (bannerState.timeout) {
            clearTimeout(bannerState.timeout);
            bannerState.timeout = null;
        }
    }
    
    // Function to initialize banner functionality
    function initializeBanner() {
        // Clean up any existing timers first
        cleanupBanner();
        
        // Get all banner items dynamically
        const bannerItems = document.querySelectorAll('.banner-section');
        const totalItems = bannerItems.length;
        
        if (totalItems === 0) {
            return;
        }
        
        // Only run rotation on mobile and tablet devices
        if (window.innerWidth <= 1024) {
            let activeIndex = 0;
            
            // Function to show specific item
            function showBannerItem(index) {
                // Hide all items first
                bannerItems.forEach((item, i) => {
                    if (i === index) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                });
            }
            
            // Show the first item initially
            showBannerItem(0);
            
            // Start rotation after initial delay
            bannerState.timeout = setTimeout(function() {
                bannerState.interval = setInterval(function() {
                    activeIndex = (activeIndex + 1) % totalItems;
                    showBannerItem(activeIndex);
                }, 3000); // Rotate every 3 seconds
            }, 2000); // Start after 2 seconds
            
        } else {
            // On desktop, show all items normally
            bannerItems.forEach(item => {
                item.classList.add('active');
            });
        }
        
        bannerState.isInitialized = true;
    }
    
    // Clean up on page unload
    window.addEventListener('beforeunload', function() {
        cleanupBanner();
    });
});
